export const postfixOperator = {
  include: '_include',
  exclude: '_exclude'
};

export const customFilterFieldPostfix = {
  fixedPeriod: '_fixedPeriod',
  dateIntervalFrom: '_dateIntervalFrom',
  dateIntervalTo: '_dateIntervalTo',
  userProfile: '_userProfile',
  number: '_number',
  decimalFrom: '_decimalFrom',
  decimalTo: '_decimalTo',
  predefDate: '_predefDate',
  notSpecified: '_notSpecified'
};

export const storePostfix = {
  ...postfixOperator,
  ...customFilterFieldPostfix
};

export const valuePropName = {
  text: 'string',
  number: 'number'
};

export const userProfileProperties = {
  unit: 'unit',
  location: 'location',
  person: 'id'
};

export const caseTypeDomainId = 100;

export const validationTranslations = {
  number_or_separator: 7725,
  required_field: 5949
};

export const numberFieldOperators = {
  largerOrEqual: '<',
  less: '>',
  between: '-'
};
